const driverSchema = {
    sequence: null,
    dataSource: null,
    isSubjectVerified: null,
    isSubjectActiveDuringMostRecentTerm: null,
    givenName: null,
    middleName: null,
    surname: null,
    nameSuffix: null,
    "dob": {
      dobPrimarySource: null,
    },
    gender: {
      "genderPrimarySource": null
    },
    ssn: null,
    maritalStatus: {
      maritalStatusPrimarySource: {
        code: null
      }
    },
    dlNumber: null,
    dlState: null,
    relationToPolicyHolder: {
      code: null,

    },
    relationToInsured: {
      code: null,
    },
    fromDate: null,
    toDate: null,
    motorVehicleReports: []
  }

  export default driverSchema;


// WEBPACK FOOTER //
// ./src/Driver/store.js